import { FC, ReactElement } from 'react'

import { LoadingScreen } from '@/components'
import { LoginScreen } from '@/containers/@screens/LoginScreen/LoginScreen'
import { localStorageApiTokenKey } from '@/helpers/authorizedFetch'
import { useLocalStorage } from '@/helpers/hooks/useLocalStorage'
import { isOptionalString } from '@/helpers/string'
import { offlineLogin, onlineLogin } from '@/redux/user/userActions'
import { useTypedDispatch, useTypedSelector } from '@/store'

export const ConnectedLoginScreen: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()

    const isOnline = useTypedSelector(state => state.appReducer.isOnline)
    const isLoading = useTypedSelector(state => state.userReducer.isLoading)
    const isUserNotFound = useTypedSelector(state => state.userReducer.isUserNotFound)
    const [, storeApiToken] = useLocalStorage(localStorageApiTokenKey, undefined, isOptionalString)

    const handleSubmit = async (employeeNumber: number, pin: string): Promise<void> => {
        if (! isOnline) {
            dispatch(offlineLogin(employeeNumber, pin))

            return
        }

        dispatch(onlineLogin(employeeNumber, pin, storeApiToken))
    }

    if (isLoading) {
        return (
            <LoadingScreen />
        )
    }

    return (
        <LoginScreen
            isUserNotFound={isUserNotFound}
            onSubmit={handleSubmit}
        />
    )
}
